export const root_api = 'http://localhost:8280/api';
export const NOT_MODIFIABLE_ROLES = ['site_administrator', "sirena_user"];
export const NO_SWITCH_ACCOUNT_ALLOWED_ROLES = ['sirena_user'];
export const NO_SWITCH_CATALOG_ALLOWED_ROLES = ['sirena_user'];